import React from 'react'
import Skeleton from 'react-loading-skeleton'

function Skli_law() {
    return (
        <>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
            <tr>
                <td className='text-center'> <Skeleton/> </td>
                <td className='text-center'><Skeleton/> </td>
                <td className='text-center w-40'><Skeleton/> </td>
            </tr>
        </>
    )
}

export default Skli_law